"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inferFn = void 0;
var inferFn = function () { return function (o) { return (o); }; };
exports.inferFn = inferFn;
